import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";
import { history } from "../helpers";

export const userService = {
  login,
  verifyMfa,
  tokenLogin,
  cookieLogin,
  logout,
  getList,
  createUser,
  editUser,
  resetPassword,
  editPassword,
  getDetail,
  getAllRoles,
  assignDoctypeToUser,
  removeDoctypeFromUser
};

async function login(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(SERVER_URL + "/auth", requestOptions)
    .then(handleLoginResponse)
    .then((user) => {
      return user;
    });
}

async function verifyMfa(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(SERVER_URL + "/auth/mfa", requestOptions)
    .then(handleLoginResponse)
    .then((user) => {
      return user;
    });
}

async function tokenLogin(input) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  };

  return fetch(SERVER_URL + "/tauth", requestOptions)
    .then(handleLoginResponse)
    .then((user) => {
      return user;
    });
}

async function cookieLogin(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(SERVER_URL + "/sessionauth", requestOptions)
    .then(handleLoginResponse)
    .then((user) => {
      return user;
    });
}

async function resetPassword(email) {
  const userRequest = { email: email };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userRequest),
  };

  let url = SERVER_URL + "/user/pwdreset";
  return fetch(url, requestOptions).then((user) => {
    return user;
  });
}

async function editPassword(user, code) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };
  const url = SERVER_URL + "/user/pwdreset?c=" + code;

  return fetch(url, requestOptions).then((user) => {
    return user;
  });
}

function logout() {
  sessionStorage.removeItem("user");
}

function handleLoginResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if problem
        logout();
        window.location.reload(true);
      }
      if (response.status === 403) {
        console.log("response status 403");
        history.push("/login?status=invalid_ip");
        console.log("pushed history to login");
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

async function getList(user_id) {
  const url = SERVER_URL + "/user";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getDetail(user_id) {
  const url = SERVER_URL + "/user/" + user_id;

  const user = await customFetch("GET", url, null, null);
  return user;
}

async function getAllRoles(user_id) {
  const url = SERVER_URL + "/role";

  const list = await customFetch("GET", url, null, null);
  return list;
}

async function createUser(userRequest) {
  let url = SERVER_URL + "/user";

  const result = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(userRequest)
  );
  return result;
}

async function editUser(user) {
  let url = SERVER_URL + "/user/" + user.user_id;

  const result = await customFetch("PUT", url, null, JSON.stringify(user));
  return result;
}

async function assignDoctypeToUser(userDoctype) {
  let url = SERVER_URL + "/user/" + userDoctype.userId + "/doctype";

  const result = await customFetch("POST", url, null, JSON.stringify(userDoctype));
  return result;
}

async function removeDoctypeFromUser(userDoctype) {
  let url = SERVER_URL + "/user/" + userDoctype.userId + "/doctype";

  const result = await customFetch("DELETE", url, null, JSON.stringify(userDoctype));
  return result;
}
